var map = {
	"./de.json": [
		81572,
		1572
	],
	"./en.json": [
		53876,
		3876
	],
	"./fr.json": [
		31947,
		1947
	],
	"./it.json": [
		43657,
		3657
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 95995;
module.exports = webpackAsyncContext;